interface PostitRequestParams {
  term: string
  municipality: string
  city: string
  address: string
  wide_number: number
  group: PostitAddressGroup
  limit?: number
}

enum PostitAddressGroup {
  City = 'city',
  Street = 'street',
  Municipality = 'municipality',
  MunicipalityCity = 'municipality_city',
}

export interface PostitAddress {
  post_code: string
  address: string
  street: string
  number: string
  only_number: string
  housing: string
  city: string
  municipality: string
  post: string
  mailbox: string
  company: string
}

export function usePostit() {
  const runtimeConfig = useRuntimeConfig()

  const suggestions = ref<PostitAddress[]>([])

  async function fetchSuggestions(params: Partial<PostitRequestParams>) {
    try {
      const { data }: { data: PostitAddress[] } = await $fetch(
        'https://api.postit.lt/',
        {
          method: 'GET',
          params: {
            ...params,
            key: runtimeConfig.public.postit,
          },
        },
      )

      suggestions.value = data
    }
    catch (error) {
      console.error('getAddressSuggestions', error)
    }
  }

  return { suggestions, fetchSuggestions }
}
